import styled from "styled-components"

export const SpacerWrappper = styled.div`
  height: 1px;
  margin: 1em 0;
`
